<!--
* @description  参数1
* @fileName  setup
* @author userName
* @date 2024-01-03 11:11:45
!-->
<template>
	<div id="setup" class="setup">
		<div class="header">
			<img src="@/assets/logo.png" width="137px" height="32px" />
		</div>
		<div class="setup-main">
			<div class="setup-title">
				<span class="icon">◆</span>
				<span class="big-title">User Account Setup</span>
			</div>
			<div class="setup-content">
				<div class="content-title">
					<div class="one">User Account Information</div>
					<div class="two">
						In order to access your company's DTMS pages, you will need
						to complete the information.
					</div>
				</div>
				<div class="form-class main-info check-price-form">
					<el-form :model="formData" :rules="allRules" ref="formData" label-position="top" size="medium"
						@submit.native.prevent class="item-Surcharge">
						<div class="form-item">
							<el-form-item class="flex-width_1" prop="name" label="Name">
								<el-input v-model="formData.name" label-width="364px"></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="email" label="New email">
								<el-input v-model="formData.email" label-width="364px"></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="Phone" label="Phone number">
								<el-input v-model="formData.Phone" label-width="364px"></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="Role" label="Role">
								<el-input v-model="formData.Role" label-width="364px"></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="Password" label="Password">
								<el-input v-model="formData.Password" label-width="364px"></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="confirmPassword" label="Confirm password">
								<el-input v-model="formData.confirmPassword" label-width="364px"></el-input>
							</el-form-item>
						</div>
					</el-form>
					<div>
						<button class="by-button--primary Comfirm" @click="clickSave">
							Comfirm
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			// 父辈向子辈传参
		},
		name: "setup",
		data() {
			return {
				formData: {
					name: "",
					email: "",
					Phone: "",
					Role: "",
					Password: "",
					confirmPassword: ""
				},
				allRules: {
					name: [{ required: true, trigger: "blur", message: "login.accountTip" }],
					email: [{ required: true, trigger: "blur", message: "login.accountTip" }],
					Role: [{ required: true, trigger: "blur", message: "login.accountTip" }],
					Password: [{ required: true, trigger: "blur", message: "login.accountTip" }],
					confirmPassword: [{ required: true, trigger: "blur", message: "login.accountTip" }]
				}
			};
		},
		created() {
			// 实例被创建之后执行代码
		},
		computed: {
			// 计算属性
		},
		components: {
			// 组件的引用
		},
		methods: {
			// 方法
			clickSave() {
				//表单校验
				this.$refs["formData"].validate((val) => {
					console.log("====校验", val);
					if (val) {}
				});
			},
		},
		mounted() {
			// 页面进入时加载内容
		},
		watch: {
			// 监测变化
		},
	};
</script>
<style scoped lang='scss'>
	::v-deep .el-form-item {
		margin-bottom: 0;

		.el-form-item__label {
			float: left;
		}
	}

	.setup {
		background: #f5f7fa;
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		min-width: 1200px;
		height: 100%;
		display: flex;
		flex-direction: column;

		.header {
			height: 80px;
			background: #ffffff;
			display: flex;
			align-items: center;
			justify-content: left;
			padding-left: 32px;
			box-shadow: rgba(0, 0, 0, 0.04) 0px 2px 8px 0px;
			position: fixed;
			left: 0px;
			width: 100%;
		}

		.setup-main {
			margin: 80px auto;

			.setup-title {
				display: flex;
				justify-content: left;
				height: 80px;
				align-items: center;

				.icon {
					font-size: 24px;
					color: #2c7eff;
					box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
					margin-right: 8px;
				}

				.big-title {
					font-size: 24px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}

			.setup-content {
				width: 800px;
				height: 500px;
				background: #ffffff;
				border-radius: 8px;

				.content-title {
					height: 48px;
					border-bottom: 1px solid rgba(221, 221, 221, 0.56);
					text-align: left;
					padding: 20px 24px;

					.one {
						font-size: 16px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						color: #333333;
						margin-bottom: 8px;
					}

					.two {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
					}
				}

				.form-class {
					margin: 16px 0 16px 24px;

					.form-item {
						width: auto;
						display: flex;
						flex-wrap: wrap;

						::v-deep .el-form-item {
							margin: 0px 24px 29px 0px;

							.el-form-item__content {
								width: 364px;
							}
						}
					}

					.Comfirm {
						width: 160px;
						height: 40px;
					}
				}
			}
		}
	}
</style>